// Hierarquia de acesso: admin > financeiro > gestor > operacional.
export const LEVELS = ['operacional', 'gestor', 'financeiro', 'admin'];

export function rank(level) {
  const i = LEVELS.indexOf(level);
  return i === -1 ? 0 : i;
}

/** Nível efetivo a partir de papeis[] acumuláveis ou nivel_acesso principal. */
export function effectiveLevel(user) {
  if (!user) return 'operacional';
  let best = user.nivel_acesso || user.access_level || 'operacional';
  const papeis = Array.isArray(user.papeis) ? user.papeis : [];
  for (const p of papeis) {
    if (rank(p) > rank(best)) {
      best = p;
    }
  }
  return best;
}

// `current` atende `required` se estiver no mesmo nível ou acima.
export function hasAccess(current, required) {
  if (!required) return true;
  return rank(current) >= rank(required);
}
